/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { FormHandles } from '@unform/core'
import { Form } from '@unform/web'
import { Base64 } from 'js-base64'
import Switch from 'react-switch'
import * as Yup from 'yup'

import { FiMail } from 'react-icons/fi'
import { MdSecurity } from 'react-icons/md'

import { BiCake } from 'react-icons/bi'
import moment from 'moment'
import getValidationErrors from '../../utils/getValidationErrors'
import usePersistedState from '../../hooks/usePersistedState'
import validaCPF from '../../utils/validaCPF'
import api from '../../services/api'

import InputSelect from '../../components/InputSelect'
import InputHidden from '../../components/InputHidden'
import Button from '../../components/Button'
import Header from '../../components/Header'
import Input from '../../components/Input'

import {
  AccessionConfigData,
  UserData,
  ConfigData,
  ErroProps,
} from '../../utils/interfaces'
import { Content, BtnModal } from './styles'
import ModalBox from '../../components/Modal'
import Container from '../../components/Container'
import Line from '../../components/Line'
import calculaIdade from '../../utils/calculaIdade'
import { DEFAULT_ACCESSION_CONFIG } from '../../utils/accessionConfig'

const Register: React.FC = () => {
  const [configData, setConfigData] = usePersistedState<ConfigData>(
    'configData',
    {} as ConfigData,
  )
  const [userData, setUserData] = usePersistedState<UserData>(
    'userData',
    {} as UserData,
  )
  const [, setErroProps] = usePersistedState<ErroProps>(
    'erroProps',
    {} as ErroProps,
  )
  const [accessionConfig] = usePersistedState<AccessionConfigData>(
    'accessionConfig',
    DEFAULT_ACCESSION_CONFIG,
  )

  const [acceptTerms, setAcceptTerms] = usePersistedState('acceptTerms', false)
  const [patrocinadora, setPatrocinadora] = useState({
    label: `${
      userData.patrocinadora === undefined ? '' : userData.dcrPatrocinadora
    }`,
    value: `${
      userData.patrocinadora === undefined ? '' : userData.patrocinadora
    }`,
  })
  const [tipoContato] = useState('E')
  const [clicado, setClicado] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [txtModal, setTxtModal] = useState('')
  const history = useHistory()
  const formRef = useRef<FormHandles>(null)

  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false)
  }, [])

  const handleSubmit = useCallback(
    async data => {
      const parsedBirthdate = moment(data.birthdate, 'DD/MM/YYYY', true)
      const minimumBirthdate = moment().subtract(150, 'years').startOf('day')
      const bday = parsedBirthdate.format('YYYY-MM-DD')
      try {
        formRef.current?.setErrors({})
        const schema = Yup.object().shape({
          cpf: Yup.string()
            .required('Digite o CPF do titular')
            .test(
              '',
              'CPF inválido',
              () =>
                validaCPF(data.cpf.replaceAll('.', '').replace('-', '')) ||
                data.cpf === '',
            ),
          birthdate: Yup.string()
            .required('Campo obrigatório')
            .test(
              '',
              'Informe a data no formato DD/MM/AAAA.',
              () =>
                moment(data.birthdate, 'DD/MM/YYYY', true).isValid() ||
                data.birthdate === '',
            )
            .test(
              '',
              'A data de nascimento não pode ser maior que hoje.',
              () =>
                !moment(data.birthdate, 'DD/MM/YYYY', true).isValid() ||
                !moment(data.birthdate, 'DD/MM/YYYY', true).isAfter(
                  moment(),
                  'day',
                ) ||
                data.birthdate === '',
            )
            .test(
              '',
              'A data de nascimento não pode ser anterior a 150 anos atrás.',
              () =>
                !moment(data.birthdate, 'DD/MM/YYYY', true).isValid() ||
                moment(data.birthdate, 'DD/MM/YYYY', true).isSameOrAfter(
                  minimumBirthdate,
                  'day',
                ) ||
                data.birthdate === '',
            )
            .test(
              '',
              'Data de nascimento inválida',
              () =>
                moment(data.birthdate, 'DD/MM/YYYY', true).isValid() ||
                data.birthdate === '',
            )
            .test(
              '',
              'Data de nascimento inválida',
              () =>
                !moment(data.birthdate, 'DD/MM/YYYY', true).isValid() ||
                calculaIdade(bday) <= 150 ||
                data.birthdate === '',
            ),
          tipContato: Yup.string().required(),
          email: Yup.string()
            .email('Digite um e-mail válido')
            .matches(
              /\S+@aspprev\.co|@basf\.co+\S/,
              'Use seu e-mail corporativo',
            )
            .required('E-mail obrigatório'),
          patrocinadora: Yup.string().required('Patrocinadora é obrigatória'),
        })

        await schema.validate(data, { abortEarly: false })

        await setUserData({
          ...userData,
          name: data.name,
          cpf: data.cpf,
          birthdate: bday,
          email: data.email,
          patrocinadora: data.patrocinadora,
          dcrPatrocinadora: patrocinadora.label,
        })

        const parametros = Base64.encode(`
            {"versao":"${configData.tipo}",
            "plano": "${configData.plano}",
            "cliente":"${configData.codCliente}",
            "cpf":"${data.cpf.replaceAll('.', '').replace('-', '')}",
            "nascimento": "${data.birthdate === undefined ? '' : bday}",
            "patrocinadora":"${data.patrocinadora}",
            "email":"${data.email === undefined ? '' : data.email}",
            "envio":"${tipoContato}"}`)

        const parametrosFinal = Base64.encode(parametros)

        await api
          .get(`wsAutenticacaoV4.rule?sys=ADZ&Entrada=${parametrosFinal}`)
          .then(res => {
            setConfigData({ ...configData, token: res.data.token, tipoContato })

            history.push('/confirm-sms')
          })
          .catch(error => {
            if (error.message === 'Network Error') {
              setErroProps({
                title: error.message,
                description: 'Falha na conexão como servidor',
              })
              setClicado(false)
              history.push('/erro')
            } else if (error.response.data.codigo === 90003) {
              setErroProps({
                title: error.response.data.titulo,
                description: `${error.response.data.descricao} (cod ${error.response.data.codigo})`,
              })
              setTxtModal(
                `${error.response.data.descricao} (cod ${error.response.data.codigo})`,
              )
              setIsModalOpen(true)
              setClicado(false)
            } else if (error.response.data.codigo === 90004) {
              setErroProps({
                title: error.response.data.titulo,
                description: `${error.response.data.descricao} (cod ${error.response.data.codigo})`,
              })
              setTxtModal(
                `${error.response.data.descricao} (cod ${error.response.data.codigo})`,
              )
              setIsModalOpen(true)
              setClicado(false)
            } else if (error.response.data.codigo === 90005) {
              setErroProps({
                title: error.response.data.titulo,
                description: `${error.response.data.descricao} (cod ${error.response.data.codigo})`,
              })
              setTxtModal(
                `${error.response.data.descricao} (cod ${error.response.data.codigo})`,
              )
              setIsModalOpen(true)
              setClicado(false)
            } else if (error.response.data.codigo === 90006) {
              setErroProps({
                title: error.response.data.titulo,
                description: `${error.response.data.descricao} (cod ${error.response.data.codigo})`,
              })
              setTxtModal(
                `${error.response.data.descricao} (cod ${error.response.data.codigo})`,
              )
              setIsModalOpen(true)
              setClicado(false)
            } else if (error.response.status === 500) {
              setErroProps({
                title: 'Erro interno no servidor',
                description: error.message,
              })
              setClicado(false)
              history.push('/erro')
            } else if (error.response.status === 404) {
              setTxtModal(
                'Não localizamos os seus dados na base cadastral. Por favor, confira as informações digitadas ou entre em contato com a área de atendimento.',
              )
              setIsModalOpen(true)
              setClicado(false)
            } else if (error.response.status === 401) {
              setTxtModal('Você já é participante do plano.')
              setIsModalOpen(true)
              setClicado(false)
            } else if (error.response.status === 417) {
              history.push('/confirm-sms')
            } else {
              setTxtModal(
                error.response.data.descricao
                  ? `${error.response.data.descricao} (cod ${error.response.data.codigo})`
                  : 'Ops, algo deu errado. Tente novamente mais tarde.',
              )
              setIsModalOpen(true)
              setClicado(false)
            }
          })
      } catch (err) {
        formRef.current?.setErrors(
          getValidationErrors(err as Yup.ValidationError),
        )
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
      }
    },
    [
      setUserData,
      userData,
      patrocinadora,
      configData,
      tipoContato,
      setConfigData,
      history,
      setErroProps,
    ],
  )

  const toggleAcceptTerms = useCallback(() => {
    window.open(
      'https://www.basf.com/br/pt/legal/politica-de-privacidade.html',
      '_blank',
    )
    setAcceptTerms(!acceptTerms)
  }, [acceptTerms, setAcceptTerms])

  const handleChangePatrocinadora = useCallback(e => {
    const t = e

    setPatrocinadora(t)
  }, [])

  const handleConfirmar = useCallback(event => {
    event.preventDefault()
    formRef.current?.submitForm()
  }, [])

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }, [])

  return (
    <>
      <Header />
      <Container>
        <Content>
          <strong>Informe seus dados para prosseguir:</strong>

          <Form
            ref={formRef}
            onSubmit={handleSubmit}
            initialData={{
              name: userData.name,
              cpf: userData.cpf,
              birthdate:
                userData.birthdate === undefined
                  ? ''
                  : userData.birthdate
                      .toString()
                      .split('-')
                      .reverse()
                      .join('/'),

              email: userData.email,
            }}
          >
            <Input
              placeholder="CPF"
              name="cpf"
              icon={MdSecurity}
              type="tel"
              mask="cpf"
            />
            <Input
              icon={BiCake}
              name="birthdate"
              placeholder="Data de nascimento"
              mask="date"
            />
            <InputSelect
              name="patrocinadora"
              value={patrocinadora}
              options={accessionConfig.listaPatrocinadoras.map(option => ({
                ...option,
                value: String(option.value),
              }))}
              onChange={e => handleChangePatrocinadora(e)}
              placeholder="Patrocinadora"
            />
            <Input
              icon={FiMail}
              name="email"
              type="email"
              placeholder="E-mail BASF"
            />

            <InputHidden name="tipContato" value={tipoContato} type="hidden" />
          </Form>

          <div>
            <small>
              Ao continuar navegando no site, você concorda com as condições de{' '}
              <a
                href="https://www.basf.com/br/pt/legal/politica-de-privacidade.html"
                target="_blank"
                rel="noopener noreferrer"
              >
                privacidade e termos de uso
              </a>
              {' do site BASF.'}
            </small>
            <Switch
              onChange={toggleAcceptTerms}
              checked={acceptTerms}
              checkedIcon={false}
              uncheckedIcon={false}
              height={20}
              width={40}
              handleDiameter={16}
              offColor="#DEE3E1"
              offHandleColor="#fff"
              onHandleColor="#fff"
              onColor="#31D19E"
            />
          </div>
          <Line />
          <small>
            Alguns dados pessoais foram recebidos do seu empregador para
            cumprimento de obrigação legal de ofertas deste plano. Caso
            necessite retificar estes dados, favor contatar o seu empregador.
          </small>
        </Content>

        <Button
          type="submit"
          color="orange"
          onClick={handleConfirmar}
          disabled={!acceptTerms || clicado}
        >
          Próximo
        </Button>
        <ModalBox isOpen={isModalOpen} onRequestClose={handleCloseModal}>
          {txtModal}
          <BtnModal isActive onClick={() => handleCloseModal()}>
            Ok
          </BtnModal>
        </ModalBox>
      </Container>
    </>
  )
}

export default Register
